import React from 'react';
import { createRemoteAppComponent } from '@module-federation/bridge-react';
import SpinnerComponent from '../../../components/SpinnerComponent';
import { useMicroFrontendNavigation } from '../../../utils/MicroFrontendContext';

const Payments = createRemoteAppComponent({
  loader: () => import('payments/Payments'),
  fallback: ({ error }) => (
    <div className="remote-error">
      <h3>❌ MF Payments Error</h3>
      <p>
        <strong>Error:</strong>{' '}
        {error?.message || 'Failed to load remote app component'}
      </p>
      <p>
        <strong>Path:</strong> payments/Payments
      </p>
    </div>
  ),
  loading: <SpinnerComponent size={24} />,
});

const ClientiRemoteApp = () => {
  const { notifyNavigationChange } = useMicroFrontendNavigation();

  return (
    <div
      style={{
        paddingTop: '20px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '400px',
        maxHeight: 'calc(100vh - 125px)',
      }}
    >
      <Payments
        basePath={'bsfood/amministrazione/clienti'}
        onNavigationChange={notifyNavigationChange}
        showBreadcrumbs={true}
      />
    </div>
  );
};

export default ClientiRemoteApp;
